
import bookCreatorProvider from "@/core/providers/book-creator";
import { upload, uploadPDF, UploadResponseModel } from "@/core/requests/book-creator";
import { toastSuccess } from "@/core/utils/notification";
import { generateRandomKey } from "@/core/utils/utils";
import MaterialLibrary from "@/views/material-library";
import { BookOpenIcon, CubeTransparentIcon, PaperAirplaneIcon, PlusIcon, QuestionMarkCircleIcon } from "@heroicons/react/24/outline";
import { ArrowUpTrayIcon, CloudIcon } from "@heroicons/react/24/solid";
import { FC, ReactNode, useState } from "react";
import { Sheet } from "react-modal-sheet";
const CreatePageSheetWrapper: FC<{
    children: ReactNode
}> = ({ children }) => {
    const [isOpened, setIsOpened] = useState<boolean>(false);
    const handleClose = () => {
        setTimeout(() => {
            setIsOpened(pre => !pre);
        });
    }

    return <>
        <div onClick={() => {
            setIsOpened(true);
        }}>
            {children}
        </div>
        <Sheet
            isOpen={isOpened} onClose={() => {
                handleClose();
            }}
            detent="full-height"
        >
            <Sheet.Container>
                <Sheet.Content>
                    <div className="py-4 bg-white dark:bg-darkBackground w-full">
                        <div className="container">
                            <header className=" text-text-light py-2 flex justify-between w-full">

                            </header>
                        </div>
                    </div>
                    <Sheet.Scroller>
                        {/* <SelectAddMethod onClose={handleClose} /> */}
                        <MaterialLibrary/>
                    </Sheet.Scroller>
                </Sheet.Content>
            </Sheet.Container>
            <Sheet.Backdrop onTap={() => {
                handleClose();
            }} />
        </Sheet>
    </>
}



/**
 * 选择新增图片方式
 */
interface ButtonModel {
    title: string,
    onChange: (files: FileList) => void,
    accept: string,
}

interface ImageItemModel {
    src: string
    key: string,
}

const SelectAddMethod: FC<{
    onClose: VoidFunction
}> = ({ onClose }) => {
    const [images, setImages] = useState<Array<ImageItemModel>>([]);
    const handleAddAllPage = () => {
        bookCreatorProvider.handleAppendMulPage(images.map(_ => _.src));
        onClose();
    }


    const handleToImage = (data: UploadResponseModel) => {

    }

    return (
        <div className="w-full h-full py-8">
            {
                (images.length !== 0) && <div>
                    <div className="px-16">
                        {/* <h1 className="m-2">选择你想要制作成页面的图片</h1> */}
                        <div className="mt-8 flex flex-wrap justify-start">
                            {images.map((image, index) => (
                                <div key={index} className="max-w-96 min-w-52 m-2 overflow-hidden rounded-md border border-gray-50 cursor-pointer hover:border-primary">
                                    <img src={`${image.src}`} alt={`uploaded-${index}`} className="object-cover w-full" />
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="sticky bottom-0 px-8 py-4 border border-y border-gray-200 bg-background flex justify-end">
                        <button className="rounded-md bg-primary text-white px-4 py-2 text-sm" onClick={handleAddAllPage}>
                            添加全部{`共(${images.length})张`}
                        </button>
                    </div>
                </div>
            }
            <div className="w-full flex justify-center mt-16 pb-16 pt-16">
                <UploadFile onSuccess={handleToImage} />
            </div>
        </div>
    );
};


const UploadFile: FC<{
    onSuccess: (data: UploadResponseModel) => void
}> = () => {
    const [over, setOver] = useState(false);
    const [uploading, setUploading] = useState(false);
    const [progress, setProgress] = useState(0);
    const fetchUpload = async (file: File) => {
        setUploading(true);
        const res = await upload(file, (progress: number) => {
            console.log("上传进度", progress)
            setProgress((progress * 100) >> 0);
        });
        setUploading(false);
        if (res?.success) {
            const data = res.data;
        }
        return res;
    }

    const handleUploadFile = (files: FileList) => {
        // Array.from(files).forEach((file)=>{
        //     // fetchUpload(file).then((res)=>{
        //     //     console.log(res)
        //     // })
        //     console.log(file)
        // })
        if (!files.length) return;
        fetchUpload(files[0]);
    }

    return <div
        onDragOver={(event) => {
            event.preventDefault();
            if (!over) {
                setOver(true);
            }
            console.log("悬空")
        }}
        onDragLeave={(event) => {
            event.preventDefault();
            if (over) {
                setOver(false);
            }
            console.log("离开")
        }}
        onDrop={(event) => {
            event.preventDefault();
            if (over) {
                setOver(false);
            }
            handleUploadFile(event.dataTransfer.files);
            // console.log(event.dataTransfer.files)
        }} className={`${over ? "border-primary" : ""} relative transition-all duration-300 hover:border-primary cursor-pointer rounded-md border-dashed border-border border-2 bg-white px-16 py-8 min-w-96 flex justify-center items-center flex-col`}>
        <ArrowUpTrayIcon className="text-info size-16" />
        {!uploading && <div className="text-center p-4 text-info">
            拖拽文件到区域内
        </div>}
        {uploading && <div className="text-center p-4 text-info">
            已上传{progress}%
        </div>}
        <input
            type="file"
            className="w-full h-full absolute opacity-0 cursor-pointer"
            // accept=
            onChange={(e) => {
                const files = e.target.files;
                if (files) {
                    handleUploadFile(files);
                }
            }}
        />
    </div>
}

export default CreatePageSheetWrapper;

// const fetchUploadPDF = async (pdf: File) => {
//     const res = await fetchUpload(pdf)
//     // if (res?.success) {
//     //     toastSuccess(res?.message);
//     //     console.log(res);
//     //     // setImages((prevImages) => [...prevImages, ...res?.data.map(_ => {
//     //     //     return {
//     //     //         src: _,
//     //     //         key: generateRandomKey(),
//     //     //     };
//     //     // })]);
//     // } else {
//     //     toastSuccess(res?.message);
//     // }
//     console.log(res);
// }

// const fetchUploadImage = async (file: File) => {
//     const res = await upload(file, (progress: number) => {
//         console.log("上传进度", progress)
//     });
//     // if (res?.success) {
//     //     toastSuccess(res?.message);
//     //     const image_url = res.data;
//     //     setImages((prevImages) => [...prevImages, { src: image_url, key: generateRandomKey(), }]);
//     // } else {
//     //     toastSuccess(res?.message);
//     // }
//     console.log(res);
// }
// 处理新增图片
//   const handleAddImage = async (files: FileList) => {
//     const file = files[0];
//     fetchUploadImage(file);
// };

// const handleAddPDF = async (files: FileList) => {
//     const file = files[0];
//     fetchUploadPDF(file);
// }